import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "nav"
};
var _hoisted_2 = {
  class: "nav-top"
};
var _hoisted_3 = {
  class: "nav-top-tabs-img"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "nav-top-tabs-img"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "nav-top-tabs-img"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  key: 0,
  class: "nav-avatar"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "nav-avatar"
};
var _hoisted_12 = ["src"];
import { ref, computed, toRefs, watch } from 'vue';
import { getStore, removeStore } from '@/util/store';
import { useRouter } from 'vue-router';
import helpDialog from '@/components/HelpDialog/index.vue';
import WujieVue from 'wujie-vue3';
import { searchHelpCenter } from '@/api/menu';
export default {
  __name: 'navLeft',
  props: {
    // 父组件传递的参数
    appInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var bus = WujieVue.bus;
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取userInfo

    var accountType = ref(userInfo.accountType);
    var homeImg = require('@/assets/home.svg');
    var homeHelpImg = require('@/assets/home-help.svg');
    var props = __props;
    var _toRefs = toRefs(props),
      appInfo = _toRefs.appInfo;
    var disabledList = ref(['helpCenter']);
    var visibleHelp = ref(false);
    var showHelpIcon = computed(function () {
      console.log(appInfo.value);
      if (!appInfo.value || !appInfo.value.app) return false;
      return !disabledList.value.includes(appInfo.value.app.alias) && hasHelpArticle.value;
    });
    // 判断是否为管理员
    var isAdmin = function isAdmin() {
      var _userInfo$memberType;
      return userInfo.memberType ? (_userInfo$memberType = userInfo.memberType) === null || _userInfo$memberType === void 0 ? void 0 : _userInfo$memberType.some(function (role) {
        return role === 'teacher';
      }) : false;
    };
    var isStudent = function isStudent() {
      var _userInfo$memberType2;
      return ((_userInfo$memberType2 = userInfo.memberType) === null || _userInfo$memberType2 === void 0 ? void 0 : _userInfo$memberType2.length) === 1 && userInfo.memberType[0] === 'student';
    };
    var handleGoSpace = function handleGoSpace() {
      if (isAdmin()) {
        // 教师个人主页
        var targetPath = "/spaceInfo";
        if (router.currentRoute.value.fullPath === targetPath) {
          // 如果当前已在目标页面，则触发刷新
          bus.$emit('refreshTeacherSpacePage');
        } else {
          router.push('/spaceInfo');
        }
      } else if (isStudent()) {
        // 学生个人主页
        var _targetPath = "/stuSpaceInfo?userId=".concat(userInfo.id, "&hideLeftBar=false");
        if (router.currentRoute.value.fullPath === _targetPath) {
          // 如果当前已在目标页面，则触发刷新
          refreshSpacePage();
        } else {
          router.push(_targetPath);
        }
      }
    };
    var mouseenter = function mouseenter(e, url) {
      e.target.className.indexOf('active') === -1 && (e.target.firstChild.src = require("@/assets/nav/".concat(url, "-active.svg")));
    };
    var mouseleave = function mouseleave(e, url) {
      e.target.className.indexOf('active') === -1 && (e.target.firstChild.src = require("@/assets/nav/".concat(url, ".svg")));
    };
    var router = useRouter();
    var refreshSpacePage = function refreshSpacePage() {
      // 通过事件总线触发刷新
      bus.$emit('refreshSpacePage');
    };
    var handleGoHome = function handleGoHome() {
      //判断当前是否存在JSAndroid方法，如果出现错误， 属于pc端
      if (window.JSAndroid) {
        window.JSAndroid.homeRefresh();
        window.JSAndroid.activityFinish();
      } else {
        router.push({
          path: '/'
        });
        bus.$emit('backHome');
      }
      // 删除审核工作台筛选条件
      if (getStore({
        name: 'sourceFilterData'
      })) {
        removeStore({
          name: 'sourceFilterData'
        });
      }
    };

    // 获取文章列表
    // 获取文章列表
    var getArticleListInfo = function getArticleListInfo(alias) {
      var accessInfo = JSON.parse(localStorage.getItem('accessInfo'));
      var userType = accessInfo.content.memberType || [];
      var data = {
        userTypes: typeof userType === 'string' ? [userType] : userType,
        // 获取用户信息
        appAlias: alias,
        isFAQ: null,
        page: 1,
        size: 1,
        isManager: false,
        publishStatus: true
      };
      return new Promise(function (resolve, reject) {
        try {
          searchHelpCenter(data).then(function (res) {
            var list = res.data.data.records || [];
            if (list.length > 0) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        } catch (e) {
          resolve(false);
        }
      });
    };
    var handleGoHelp = function handleGoHelp() {
      visibleHelp.value = true;
    };
    var hasHelpArticle = ref(false);
    var handleIsHelpArticle = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(alias) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getArticleListInfo(alias);
            case 1:
              hasHelpArticle.value = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function handleIsHelpArticle(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(function () {
      return appInfo.value;
    }, function (newVal) {
      console.log(newVal);
      if (!newVal || !newVal.app) return;
      handleIsHelpArticle(newVal.app.alias);
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      handleGoHome: handleGoHome,
      handleGoHelp: handleGoHelp
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, function () {
        return [_createElementVNode("div", _hoisted_2, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "nav-top-logo"
        }, null, -1)), _createElementVNode("div", {
          class: _normalizeClass(["nav-top-tabs", {
            active: _ctx.$route.name === 'accountInfo'
          }]),
          onClick: _cache[0] || (_cache[0] = function ($event) {
            return _ctx.$router.push('/accountInfo');
          }),
          onMouseenter: _cache[1] || (_cache[1] = function (e) {
            return mouseenter(e, 'accinfo');
          }),
          onMouseleave: _cache[2] || (_cache[2] = function (e) {
            return mouseleave(e, 'accinfo');
          })
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          src: require("@/assets/nav/".concat(_ctx.$route.name === 'accountInfo' ? 'accinfo-active' : 'accinfo', ".svg"))
        }, null, 8, _hoisted_4)]), _cache[9] || (_cache[9] = _createElementVNode("div", null, "帐号信息", -1))], 34), accountType.value !== 0 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["nav-top-tabs", {
            active: _ctx.$route.name === 'userInfo'
          }]),
          onClick: _cache[3] || (_cache[3] = function ($event) {
            return _ctx.$router.push('/userInfo');
          }),
          onMouseenter: _cache[4] || (_cache[4] = function (e) {
            return mouseenter(e, 'user');
          }),
          onMouseleave: _cache[5] || (_cache[5] = function (e) {
            return mouseleave(e, 'user');
          })
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: require("@/assets/nav/".concat(_ctx.$route.name === 'userInfo' ? 'user-active' : 'user', ".svg")),
          class: "nav-top-tabs-img"
        }, null, 8, _hoisted_6)]), _cache[10] || (_cache[10] = _createElementVNode("div", null, "个人信息", -1))], 34)) : _createCommentVNode("", true), isAdmin() || isStudent() ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["nav-top-tabs", {
            active: _ctx.$route.name === 'spaceInfo' || _ctx.$route.name === 'stuSpaceInfo'
          }]),
          onClick: handleGoSpace,
          onMouseenter: _cache[6] || (_cache[6] = function (e) {
            return mouseenter(e, 'space');
          }),
          onMouseleave: _cache[7] || (_cache[7] = function (e) {
            return mouseleave(e, 'space');
          })
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: require("@/assets/nav/".concat(_ctx.$route.name === 'spaceInfo' || _ctx.$route.name === 'stuSpaceInfo' ? 'space-active' : 'space', ".svg")),
          class: "nav-top-tabs-img"
        }, null, 8, _hoisted_8)]), _cache[11] || (_cache[11] = _createElementVNode("div", null, "个人主页", -1))], 34)) : _createCommentVNode("", true)])];
      }), showHelpIcon.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
        class: "nav-avatar-help",
        onClick: handleGoHelp
      }, [_createElementVNode("img", {
        src: _unref(homeHelpImg)
      }, null, 8, _hoisted_10)]), _cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "nav-avatar-text"
      }, "帮助中心", -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        class: "nav-avatar-home",
        onClick: handleGoHome
      }, [_createElementVNode("img", {
        src: _unref(homeImg)
      }, null, 8, _hoisted_12)]), _cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "nav-avatar-text"
      }, "回首页", -1))]), showHelpIcon.value ? (_openBlock(), _createBlock(helpDialog, {
        key: 1,
        visible: visibleHelp.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = function ($event) {
          return visibleHelp.value = $event;
        }),
        alias: _unref(appInfo).app.alias,
        name: _unref(appInfo).app.name,
        class: "help-dialog-container"
      }, null, 8, ["visible", "alias", "name"])) : _createCommentVNode("", true)]);
    };
  }
};